import React, { useState, useRef } from "react";
import styles from "./OrdersTab.module.scss";
import { Stack } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Container } from "@mui/system";
import Breadcrumb from "../../../components/Breadcrumb/MuiBreadcrumb";
import SegmentedControlGroup from "../../../components/SegmentedControlGroup/SegmentedControlGroup";
import Icon from "../../../components/Icon/Icon";
import { useTranslation } from "react-i18next";
import OrdersDetails from "../OrdersDetails/OrdersDetails";
import OrdersEqiupment from "../OrdersEquipment/OrdersEquipment";
import OrdersNotes from "../OrdersNotes/OrdersNotes";
import PrescriptionListing from "../../prescription-module/prescription-listing/prescription-listing";
import { useSelector } from "react-redux";
import SupplyDetails from "../supply-details/supply-details";
import { useLocation } from "react-router-dom";
import SupplyEquipment from "../SupplyEquipment/SupplyEquipment";
import CustomTabPanel from "../../../components/CustomTabPanel/CustomTabPanel";
import PreAuthorizationTab from "../../../components/PreAuthorizationTab/PreAuthorizationTab";
import PageTour from "../../../common/WalkThrough/pageTour/pageTour";
import { useTheme } from "@mui/material/styles";
import { ProfileTab } from "../../../components/ProfileTab/ProfileTab";

const OrdersTab = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [orderDetails, setOrderDetails] = useState("");
  const [supplyDetails, setSupplyDetails] = useState("");
  const [orderPatientId, setOrderPatientId] = useState("");
  const breadcrumbItems = [
    { label: "Orders", link: `/orders` },
    { label: location.pathname.includes("supply") ? supplyDetails : orderDetails }
  ];
  const companySettings = useSelector(state => state.authState.userData?.data?.company_settings);
  const showOrdersPreAuthModule = companySettings?.find(val => val.module_id == 76)
  const isO2prescriptionModule = companySettings?.find(val => val.module_id == 91)

  const [selectedValue, setSelectedValue] = React.useState(0);
  const userChangedTabRef = useRef(false);
  const handleChange = (event, newValue) => {
    userChangedTabRef.current = true;
    setSelectedValue(newValue);
  };
  const tabsData = [
    { key: 'details', icon: <Icon icon="fa-file-lines" />, iconPosition: 'start', label: 'Details', component: <OrdersDetails setOrder={setOrderDetails} setOrderPatientId={setOrderPatientId} />, show: true },
    { key: 'equipment', icon: <Icon icon="fa-wheelchair" />, iconPosition: 'start', label: 'Equipment', component: <OrdersEqiupment />, show: true },
    { key: 'preauth', icon: <Icon icon="fa-clipboard-clock" />, iconPosition: 'start', label: t('PatientsTabs.preAuth'), component: <PreAuthorizationTab patientId={orderPatientId} />, show: showOrdersPreAuthModule },
    { key: 'documents', icon: <Icon icon="fa-folder-open" className="Documents" />, iconPosition: 'start', label: t('PatientsTabs.documents'), component: <PrescriptionListing />, show: true },
    { key: 'notes', icon: <Icon icon="fa-message" />, iconPosition: 'start', label: t('PatientsTabs.notes'), component: <OrdersNotes />, show: true }
  ];
  const supplyTabsData = [
    { key: 'details', icon: <Icon icon="fa-file-lines" />, iconPosition: 'start', label: 'Details', component: <SupplyDetails setOrder={setSupplyDetails} />, show: true },
    { key: 'supplies', icon: <Icon icon="fa-box" />, iconPosition: 'start', label: 'Supplies', component: <SupplyEquipment />, show: true },
    { key: 'notes', icon: <Icon icon="fa-message" />, iconPosition: 'start', label: t('PatientsTabs.notes'), component: <OrdersNotes />, show: true }
  ];
  const filteredOrdersTabsData = location.pathname.includes("supply") ? supplyTabsData.filter(tab => tab.show) : tabsData.filter(tab => tab.show);

  // Hash-based default tab selection e.g. /orders/order-details/123#notes
  React.useEffect(() => {
    if (location.hash && !userChangedTabRef.current) {
      const hashKey = location.hash.replace('#', '').toLowerCase();
      const idx = filteredOrdersTabsData.findIndex(tab => tab.key.toLowerCase() === hashKey);
      if (idx >= 0) {
        setSelectedValue(idx);
      }
    }
  }, [location.hash, filteredOrdersTabsData]);

  return (
    <>
      {<PageTour prop={'OrderDetailsTab'} />}
      <Stack spacing={3} sx={{ px: 3 }} data-testid="OrdersTab">
        <Breadcrumb items={breadcrumbItems} />
        {isMobileScreen ?
          <ProfileTab
            tabsData={filteredOrdersTabsData}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
          /> :
          <SegmentedControlGroup
            tabs={filteredOrdersTabsData}
            value={selectedValue}
            onChange={handleChange}
            size="lg"
            fullWidth
          />
        }
        {filteredOrdersTabsData.map((tab, index) => (
          <CustomTabPanel key={tab.key} value={selectedValue} index={index}>
            {tab.component}
          </CustomTabPanel>
        ))}
      </Stack>
    </>
  );
};

export default OrdersTab;